import { JoggApiOption } from "./client"

export const replicateCartBase =
    ({ execute }: Pick<JoggApiOption, "execute">) =>
    async (cartId: string) => {
        return execute({
            method: "POST",
            uri: `/ctp/carts/${cartId}/replicate`,
        })
    }
